import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { GruppeProdukt } from './gruppe-produkt.model';

@Injectable({
  providedIn: 'root',
})
export class GruppeProduktApi extends RestApi<GruppeProdukt> {
  override endpoint = '/api/admin/gruppeprodukter';
}
